"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrUspBox = void 0;
const react_1 = __importDefault(require("react"));
const fdr_usp_boxes_styles_1 = require("./fdr-usp-boxes.styles");
const FdrUspBox = ({ title, subtitle, text, icon, children, link, className, }) => {
    return (react_1.default.createElement(fdr_usp_boxes_styles_1.USPBoxWrapper, { "data-id": "usp-box", className: `${className} ${(link === null || link === void 0 ? void 0 : link.url) ? 'with-link' : 'without-link'}` },
        title ? react_1.default.createElement(fdr_usp_boxes_styles_1.USPTitle, { "data-id": "usp-title" }, title) : null,
        subtitle ? (react_1.default.createElement(fdr_usp_boxes_styles_1.USPSubTitle, { "data-id": "usp-subtitle" }, subtitle)) : null,
        children,
        icon ? react_1.default.createElement(fdr_usp_boxes_styles_1.USPIcon, { image: icon }) : null,
        text ? (react_1.default.createElement(fdr_usp_boxes_styles_1.USPText, { "data-id": "usp-text", dangerouslySetInnerHTML: { __html: text } })) : null,
        react_1.default.createElement(fdr_usp_boxes_styles_1.USPLinkWrapper, { link: link })));
};
exports.FdrUspBox = FdrUspBox;
//# sourceMappingURL=fdr-usp-box.js.map